import { z } from "zod";

export const POSITION_ZONES = [
  "SidelineA",
  "SidelineB",
  "DeadBall",
  "TwentyTwo",
  "InGoal",
  "Halfway",
  "Other",
] as const;

export const createAssetSchema = z.object({
  asset_type_id: z.string().min(1, "Asset type is required"),
  name: z.string().max(255).nullable().optional(),
  position_zone: z.enum(POSITION_ZONES).nullable().optional(),
  position_x: z.number().nullable().optional(),
  position_y: z.number().nullable().optional(),
  rotation: z.number().default(0),
});

export const updateAssetSchema = z.object({
  name: z.string().max(255).nullable().optional(),
  position_zone: z.enum(POSITION_ZONES).nullable().optional(),
  position_x: z.number().nullable().optional(),
  position_y: z.number().nullable().optional(),
  rotation: z.number().optional(),
});

export const createAdSpaceSchema = z.object({
  name: z.string().min(1, "Name is required").max(255),
  width_mm: z.number().int().min(1, "Width must be positive"),
  height_mm: z.number().int().min(1, "Height must be positive"),
  offset_x_mm: z.number().int().default(0),
  offset_y_mm: z.number().int().default(0),
  sort_order: z.number().int().min(0).default(0),
});

export const updateAdSpaceSchema = z.object({
  name: z.string().min(1, "Name is required").max(255).optional(),
  width_mm: z.number().int().min(1).optional(),
  height_mm: z.number().int().min(1).optional(),
  offset_x_mm: z.number().int().optional(),
  offset_y_mm: z.number().int().optional(),
  sort_order: z.number().int().min(0).optional(),
});

export type CreateAssetInput = z.infer<typeof createAssetSchema>;
export type UpdateAssetInput = z.infer<typeof updateAssetSchema>;
export type CreateAdSpaceInput = z.infer<typeof createAdSpaceSchema>;
export type UpdateAdSpaceInput = z.infer<typeof updateAdSpaceSchema>;
